const position = [
    { label: 'Goalie', value: 'Goalie' },
    { label: 'Verteidiger', value: 'Defence' },
    { label: 'Stürmer', value: 'Attacker' },
];

export { position };
